var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1234 78.5234C47.7234 61.3234 61.3234 47.8234 78.5234 42.1234C79.7234 41.7234 80.3234 40.4234 79.9234 39.3234C79.7234 38.6234 79.2234 38.1234 78.5234 37.9234C61.2234 32.3234 47.7234 18.8234 42.1234 1.52341C41.7234 0.323409 40.4234 -0.276591 39.3234 0.123409C38.6234 0.323409 38.1234 0.823409 37.9234 1.52341C32.2234 18.8234 18.7234 32.3234 1.52341 37.9234C0.323409 38.3234 -0.276591 39.6234 0.123409 40.7234C0.323409 41.4234 0.823409 41.9234 1.52341 42.1234C18.7234 47.7234 32.2234 61.2234 37.9234 78.5234C38.3234 79.7234 39.6234 80.3234 40.7234 79.9234C41.3234 79.7234 41.8234 79.2234 42.1234 78.5234Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.52344 42.1234C18.7234 47.7234 32.2234 61.2234 37.9234 78.5234C38.3234 79.7234 39.6234 80.3234 40.7234 79.9234C41.4234 79.7234 41.9234 79.2234 42.1234 78.5234C47.7234 61.3234 61.3234 47.8234 78.5234 42.1234C70.3234 44.8234 56.5234 46.9234 40.0234 46.9234C23.5234 46.9234 9.62344 44.8234 1.52344 42.1234Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoula);
export default __webpack_public_path__ + "static/media/youla.571be530.svg";
export { ForwardRef as ReactComponent };